
if(window.location.pathname.includes('the-halloween-collection')){

  const hookElement = document.querySelector(`div[data-product-handle="scaredy-bats-two-piece-pajama-set"]`);
  const hookElementShoppable = document.querySelector(`div[data-product-handle="girly-ghouls-two-piece-pajama-set"]`);
  
  const tolstoyContainer = document.createElement("div");
  tolstoyContainer.setAttribute("class","grid__item grid-product small--one-half medium-up--one-quarter aos-init aos-animate");
  tolstoyContainer.innerHTML = `
      
      <tolstoy-tile
        data-tags="{% for tag in product.tags -%}{{ tag }},{%- endfor %}"
        class="tolstoy-tile"
        data-publish-id="7878cvupno5do" 
        data-product-id="{{ product.id }}">
      </tolstoy-tile>
    
    `;
  
  const tolstoyContainerShoppable = document.createElement("div");
  tolstoyContainerShoppable.setAttribute("class","grid__item grid-product small--one-half medium-up--one-quarter aos-init aos-animate");
  tolstoyContainerShoppable.innerHTML = ` 
      <tolstoy-carousel
        data-tags="{% for tag in product.tags -%}{{ tag }},{%- endfor %}"
        class="tolstoy-carousel"
        data-publish-id="04is33rr7qjs3" 
        data-product-id="{{ product.id }}">
      </tolstoy-carousel>
    
    `
  
  // hookElement.after(tolstoyContainer);
  hookElementShoppable.after(tolstoyContainerShoppable);
  
  console.log("pathname", window.location.pathname);
 }

